/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseLong } from '../../models/api-response-long';

export interface GetCountByConversationReferenceAndCompanyId$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  convRef: string;
}

export function getCountByConversationReferenceAndCompanyId(http: HttpClient, rootUrl: string, params: GetCountByConversationReferenceAndCompanyId$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLong>> {
  const rb = new RequestBuilder(rootUrl, getCountByConversationReferenceAndCompanyId.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('convRef', params.convRef, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseLong>;
    })
  );
}

getCountByConversationReferenceAndCompanyId.PATH = '/v1/api/ui/note-conversation/count/{convRef}';
